/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryResponse } from '../../models/registry-response';

export interface RegistryControllerGetAll$Params {
  query?: string;
  main_contact?: string;
  vat_number?: string;
  country_iso?: string;
  province?: string;
  city?: string;
  showAbnormalRegistries?: boolean;
  agreement_id?: number;
  service_id?: number;
  contact_types?: Array<number> | null;
  limit: number;
  skip: number;
  order_by?: string;
  order_direction?: string;
}

export function registryControllerGetAll(http: HttpClient, rootUrl: string, params: RegistryControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, registryControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('main_contact', params.main_contact, {});
    rb.query('vat_number', params.vat_number, {});
    rb.query('country_iso', params.country_iso, {});
    rb.query('province', params.province, {});
    rb.query('city', params.city, {});
    rb.query('showAbnormalRegistries', params.showAbnormalRegistries, {});
    rb.query('agreement_id', params.agreement_id, {});
    rb.query('service_id', params.service_id, {});
    rb.query('contact_types', params.contact_types, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryResponse;
      }>;
    })
  );
}

registryControllerGetAll.PATH = '/registry';
